export default "__VITE_ASSET__BWMaDY7F__"